var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-start justify-start flex-column"},[_c('v-simple-checkbox',{attrs:{"hide-details":"","value":_vm.isActive,"disabled":_vm.isDisabled},on:{"input":_vm.onClick}}),_vm._v(" "+_vm._s(this.header.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }